export const SCREEN_ID = {
  NOTIFICATION_LIST: 239,
  LEARNING_CENTER: 260,
};

export const EVENT_TYPE = {
  BROADCAST: "BROADCAST",
  FAILED_TOAST: "FAILED_TOAST",
  SUCCESS_TOAST: "SUCCESS_TOAST",
  BROADCAST_SUCCESS: "BROADCAST_SUCCESS",
  REMINDER_SENDS_SUCCESS: "REMINDER_SENDS_SUCCESS",
};

export const POST_MESSAGE_CHILD = "REFRESH_NOTIFICATION_TABLE";